module.exports = __webpack_public_path__ + "static/media/component4.dd5334d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component4.png
// module id = 2408
// module chunks = 0